import React from 'react';
import '../../index.css'; // 假设CSS样式保存在这个文件中

const Lang = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">多语言功能使用案例</h1>

      <div className="section">
        <p>如果您的餐厅开在景区，每日接待来自世界各国的游客。或者您是一位海外经营中餐厅的华人，顾客甚至员工都来自不同国家，那么多语言模块就是为您量身打造，是解决多语言环境下沟通问题的利器。</p>
        {/*[此处放1-2张餐厅的真实照片]*/}
        {/*<img src="./lang/img.png" style={{maxWidth: '600px'}} alt="多设备显示效果"/>*/}

      </div>

      <div className="section">
        <h2>面临的挑战</h2>
        <p>面对来自世界各地的客人，传统的方案便是准备中英等多语菜单。但菜单篇幅有限，不可能满足众多语种的需求，更重要的是点餐过程依然需要服务员和客人进行沟通，在语言不通的情况下，沟通效率和体验都非常不理想。必然导致客户的流失。
        </p>
        <p>1. 不同语言的顾客因点餐困难, 用餐体验差,造成了很严重的客源流失.</p>
        {/* <img src="./lang/img_1.png" alt="前台"/>
        <img src="./lang/img_2.png" alt="桌子"/> */}
        <p>2. 服务员与语言不通的客人的沟通花费大量时间, 降低了工作效率, 增加了其他客人的等待时间.</p>
        <p>3. 员工使用不同语言, 例如有些餐厅拥有从其他国家来的后厨员工, 服务员和后厨使用不同语言沟通效率低, 更容易出错.</p>
        {/*[此处放一张表示焦头烂额的图片]*/}
        <img src="./lang/img_3.png" style={{width: '400px'}} alt="多设备显示效果"/>

      </div>

      <div className="section">
        <h2>解决方案</h2>
        <p>在使用多语言功能的情况下，客人进店只需要引导其扫码二维码，软件会自动检测客人手机的系统语言，并提供对应语言的操作界面和菜品信息，不但操作按钮是客人熟悉的语言,
        甚至包括菜品的名称, 规格, 描述等都会展示为客人的语言.完美的本地化体验会让客人甚至感觉不到这是一家异国餐厅。100%本土化的点餐方式将提供给客人最流畅的点餐体验. 增加用户满意度的同时, 还可以有效的降低服务员的工作负担.</p>
        {/*[这里放一张示例餐厅的餐牌图片, 二维码替换为后台的预览模式二维码, 只能看不能下单, 二维码下面放一行醒目一点的字, 提示可以扫码体验]*/}
        {/* <img src="./lang/img_4.jpg" style={{width: '200px'}} alt=""/> */}
        {/*[这里放示例餐厅的餐牌图片]*/}
        {/*[这里放同一个页面, 两种语言下的效果对比截图]*/}
        <p>下面是来自加拿大的一个真实用户的例子:</p>
        <p>如果客人的手机系统为汉语, 扫码后会自动显示汉语界面, 如下图所示</p>
        <img src="./lang/img_5.png" style={{width: '400px'}} alt=""/>
        <p>如果客人的手机系统为英语, 扫码后会自动显示英文界面, 如下图所示</p>
        <img src="./lang/img_5_1.png" style={{width: '400px'}} alt=""/>
        <p>当然用户也可以切换显示的语言, 如下图所示(支持的语言种类取决于店铺开通的语言种类):</p>
        <img src="./lang/img_6.png" style={{width: '400px'}} alt=""/>
        <p>如果后厨的语言不同, 我们为多个后厨分别安装小票打印机, 客人下单后, 系统会自动发送菜品给相应的后厨,
          西餐后厨打印英文小票, 中餐后厨打印中文小票. 订单信息清晰明了, 后厨的工作也井然有序了很多.</p>
        {/*[这里放两张小票图片, 一张西班牙语后厨, 一张中文后厨]*/}
        <img src="./lang/ticket-chinese-english.jpg" style={{width: '400px'}} alt=""/>
        <p>如果同一个后厨需要多种语言, 也可以在一张小票上打印两种语言.</p>
        <img src="./lang/ticket-chinese-english-samePage.jpg" style={{width: '400px'}} alt=""/>
        <p>解决不同语言后厨和服务员的沟通问题, 我们在后厨打印机开启了一菜一单模式, 这样后厨每出餐一个菜品,
          都附带小票一起交给服务员. 同时打开多语言小票模式, 让每张小票都同时展示中文和英语两种信息.
          这样一来服务员和后厨无需再通过对话沟通上菜信息, 整体效率和准确度大大增加了.</p>
        <img src="./lang/ticket-chinese-english-one-dish-one-page.jpg" style={{width: '400px'}} alt=""/>
        {/*[这里放一菜一单和小票打印两种语言配置下的后厨小票图片]*/}
        <p>除了小票之外, 我们的app也是支持多种语言的, 员工可以用自己最熟悉的语言来工作.</p>
        {/*[这里放店长端中文报表页面截图, 以及西班牙语前台页面截图]-*/}
        <img src="./lang/test1.png" alt=""/>
        <img src="./lang/test2-1.png" alt=""/>
      </div>

      <div className="section">
        <h2>实施效果</h2>
        <p>通过以上方法, 餐厅终于可以高效和流畅的服务客人了, 随着客人的满意度增加,
          餐厅的生意也越来越好了.如果您的餐厅也面临着类似的问题, 那请不要犹豫, Order multi就是您所需要的.</p>
      </div>

      <div className="section">
        <p>Order multi目前已支持: 英语、简体中文、 繁体中文、 西班牙语、 葡萄牙语、 法语、 德语、 意大利语、 捷克语、 日语、 韩语、
          越南语、 维吾尔语. </p>
        <p>如果您有其他语言需求, 请联系客服.</p>
      </div>


      {/* <div className="section">
        <p>后厨除了通过打印小票获取订单信息之外, 我们也支持使用后厨显示系统(KDS)来展示后厨订单,
          厨师可以通过大屏幕来更直观的了解订单情况. <a href="contact_page_url">点击这里来查看详情</a></p> */}
        {/*[这里放一张后厨KDS的示意照片, 可以用麦当劳之类的]*/}
        {/* <img src="./lang/test3.png" alt=""/>
      </div> */}
    </div>
  );
};

export default Lang;
